/**
 * Determines whether the cart page will be rendered with RSC
 */
export const CART_RSC_240828 = 'CART_RSC_240828';
